<template>
	<el-container class="userEquity page-x" direction="vertical">
		<el-tabs v-model="productFlag" @tab-click="handleClick">
			<el-tab-pane
				v-for="(item, idx) in tabList"
				:key="idx"
				:label="item.label"
				:name="item.id"
			>
			</el-tab-pane>
		</el-tabs>
		<div class="search-x">
			<div v-if="findTable('userInfo')" class="search-item">
				<span class="label">用户信息</span>
				<el-input
					class="input-box"
					clearable
					placeholder="用户ID、姓名、手机号、证件号"
					v-model.trim="searchBox.userInfo"
				></el-input>
			</div>
			<div v-if="findTable('serviceNo')" class="search-item">
				<span class="label">服务单号</span>
				<el-input
					class="input-box"
					placeholder="请输入服务单号"
					clearable
					v-model.trim="searchBox.serviceNo"
				></el-input>
			</div>
			<div v-if="findTable('orgManagement')" class="search-item">
				<span class="label">管理机构</span>
				<select-all
					v-model="searchBox.orgManagements"
					filterable
					:data="
						productFlag == '1'
							? optionsData.prodOrgManagementList
							: optionsData.unProdOrgManagementList
					"
					:option="{ label: 'label', value: 'orgManagementCode' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('branchOffice')" class="search-item">
				<span class="label">分公司</span>
				<select-all
					v-model="searchBox.branchOffices"
					filterable
					:data="
						productFlag == '1'
							? optionsData.prodBranchOfficeList
							: optionsData.unProdBranchOfficeList
					"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>
			<div v-if="productFlag == 0" class="search-item">
				<span class="label">数据来源</span>
				<select-all
					v-model="searchBox.dataSources"
					:data="dataSourceList"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>

			<div v-if="productFlag == 1" class="search-item">
				<span class="label">数据来源</span>
				<select-all
					v-model="searchBox.dataSources"
					:data="dataSourceList01"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('itemNames')" class="search-item">
				<span class="label">服务项目</span>
				<select-all
					v-model="searchBox.itemNames"
					filterable
					:data="
						productFlag == '1'
							? serviceData.prodItemList
							: serviceData.unProdItemList
					"
					:option="{ label: 'itemName', value: 'itemName' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('serviceTypeId')" class="search-item">
				<span class="label">服务类别</span>
				<el-cascader
					placeholder="请选择服务类别"
					clearable
					v-model="searchBox.serviceTypeIds"
					:options="serviceTypeList"
					:props="{
						value: 'id',
						label: 'name',
						emitPath: false,
						multiple: true,
					}"
				></el-cascader>
			</div>
			<div v-if="findTable('serviceModeId')" class="search-item">
				<span class="label">服务提供方式</span>
				<el-cascader
					clearable
					placeholder="请选择服务提供方式"
					v-model="searchBox.serviceModeIds"
					:options="serviceModeList"
					:props="{
						value: 'id',
						label: 'name',
						emitPath: false,
						multiple: true,
					}"
				></el-cascader>
			</div>
			<div v-if="findTable('providerId')" class="search-item">
				<span class="label">供应商</span>
				<select-all
					v-model="searchBox.providerIds"
					:data="supplierList"
					:option="{ label: 'providerName', value: 'id' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('vipLevel')" class="search-item">
				<span class="label">VIP级别</span>
				<select-all
					v-model="searchBox.vipLevels"
					:data="optionsData.vipLevelList"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('serviceDepartment')" class="search-item">
				<span class="label">权益来源</span>
				<select-all
					v-model="searchBox.serviceDepartments"
					:data="optionsData.serviceDepartmentList"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('activeYear')" class="search-item">
				<span class="label">激活年度</span>
				<el-date-picker
					v-model="timeCache.activeYear"
					@change="(e) => toChangeTimeOne(e, 'activationStart')"
					type="year"
					placeholder="请选择激活年度"
					:picker-options="pickerOptions"
				>
				</el-date-picker>
			</div>
			<div
				v-if="findTable('insuranceProductCategories')"
				class="search-item"
			>
				<span class="label">保险产品类别</span>
				<select-all
					v-model="searchBox.insuranceProductCategories"
					:data="optionsData.insuranceProductCategoryList"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>

			<div
				v-if="findTable('insuranceProductCategories')"
				class="search-item"
			>
				<span class="label">赔案号</span>

				<el-input
					class="input-box"
					clearable
					placeholder="请输入赔案号"
					v-model.trim="searchBox.caseNumberLike"
				></el-input>
			</div>

			<div v-if="findTable('policyNoLike')" class="search-item">
				<span class="label">保单号</span>
				<el-input
					class="input-box"
					clearable
					placeholder="请输入保单号"
					v-model.trim="searchBox.policyNoLike"
				></el-input>
			</div>

			<div v-if="findTable('caseTimeBegin')" class="search-item">
				<span class="label">结案时间</span>
				<el-date-picker
					v-model="timeCache.caseTime"
					@change="
						(e) => toChangeTime(e, 'caseTimeBegin', 'caseTimeEnd')
					"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="timestamp"
					:default-time="['00:00:00', '23:59:59']"
				>
				</el-date-picker>
			</div>

			<div v-if="findTable('policyStatues')" class="search-item">
				<span class="label">保单状态</span>
				<select-all
					v-model="searchBox.policyStatues"
					:data="policyStatuesArray"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>

			<div v-if="findTable('caseTypeLike')" class="search-item">
				<span class="label">赔付责任类型</span>
				<el-input
					class="input-box"
					clearable
					placeholder="请输入赔付责任类型"
					v-model.trim="searchBox.caseTypeLike"
				></el-input>
			</div>

			<div v-if="findTable('productNameLike')" class="search-item">
				<span class="label">保险产品名称</span>
				<el-input
					class="input-box"
					clearable
					placeholder="请输入保险产品名称"
					v-model.trim="searchBox.productNameLike"
				></el-input>
			</div>
			<div v-if="findTable('channel')" class="search-item">
				<span class="label">渠道</span>
				<select-all
					v-model="searchBox.channels"
					:data="optionsData.channelList"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('serviceStatus')" class="search-item">
				<span class="label">服务状态</span>
				<select-all
					v-model="searchBox.serviceStatuses"
					:data="serverStatus"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('status')" class="search-item">
				<span class="label">状态</span>
				<select-all
					v-model="searchBox.status"
					:data="statusArr"
					:option="{ label: 'label', value: 'value' }"
				>
				</select-all>
			</div>
			<div v-if="findTable('activeBeginTime')" class="search-item">
				<span class="label">激活开始时间</span>
				<el-date-picker
					v-model="timeCache.activeBeginTime"
					@change="
						(e) =>
							toChangeTime(
								e,
								'activeBeginTimeStart',
								'activeBeginTimeEnd'
							)
					"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
				>
				</el-date-picker>
			</div>
			<div v-if="findTable('beginTime')" class="search-item">
				<span class="label">开通时间</span>
				<el-date-picker
					v-model="timeCache.beginTime"
					@change="
						(e) => toChangeTime(e, 'beginTimeStart', 'beginTimeEnd')
					"
					type="daterange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="timestamp"
					:default-time="['00:00:00', '23:59:59']"
				>
				</el-date-picker>
			</div>

			<el-button
				v-auth="'sa_provider_page'"
				type="primary"
				class="search-btn"
				@click="toSearch"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="goReset()"
				>重置</el-button
			>
			<el-button class="search-btn" @click="toExport" type="primary"
				>导出数据</el-button
			>
		</div>
		<div class="cont-x" ref="tableBox">
			<el-table
				:key="productFlag"
				v-loading="loading"
				:data="tableData"
				height="600"
				border
				class="mb20"
			>
				<el-table-column
					v-if="findTable('userId')"
					width="80px"
					align="center"
					label="用户ID"
					prop="userId"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('serviceNo')"
					width="120px"
					align="center"
					label="服务单号"
					prop="serviceNo"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('name')"
					width="80px"
					align="center"
					label="姓名"
					prop="name"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('gender')"
					width="80px"
					align="center"
					label="性别"
					prop="gender"
				>
					<template slot-scope="scoped">
						<span v-if="scoped.row.gender === 0">{{ "男" }}</span>
						<span v-if="scoped.row.gender === 1">{{ "女" }}</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('age')"
					width="80px"
					align="center"
					label="年龄"
					prop="age"
				>
					<template slot-scope="scoped">
						{{ scoped.row.age ? scoped.row.age : "" }}
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('cardType')"
					width="80px"
					align="center"
					label="证件类型"
					prop="cardType"
				>
					<template slot-scope="scoped">
						<span>{{
							cardType[scoped.row.cardType] || scoped.row.cardType
						}}</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('cardNo')"
					width="80px"
					align="center"
					label="证件号码"
					prop="cardNo"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('mobile')"
					width="80px"
					align="center"
					label="联系电话"
					prop="mobile"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('marital')"
					width="80px"
					align="center"
					label="婚姻状况"
					prop="marital"
				>
					<template slot-scope="scoped">
						{{ scoped.row.marital | statusFilter(maritalOption) }}
					</template>
				</el-table-column>

				<el-table-column
					v-if="findTable('specialContent')"
					width="80px"
					align="center"
					label="特约内容"
					prop="specialContent"
				>
				</el-table-column>

				<el-table-column
					v-if="findTable('caseConclusion')"
					width="80px"
					align="center"
					label="理赔结论"
					prop="caseConclusion"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('socialSecurityName')"
					width="80px"
					align="center"
					label="社保标识"
					prop="socialSecurityName"
				>
				</el-table-column>

				<el-table-column
					v-if="findTable('caseNumber')"
					width="80px"
					align="center"
					label="赔案号"
					prop="caseNumber"
				>
				</el-table-column>

				<el-table-column
					v-if="findTable('policyStatus')"
					width="80px"
					align="center"
					label="保单状态"
					prop="policyStatus"
				>
					<template slot-scope="scoped">
						{{
							scoped.row.policyStatus
								| statusFilter(policyStatuesArray)
						}}
					</template>
				</el-table-column>

				<el-table-column
					v-if="findTable('caseTime')"
					width="80px"
					align="center"
					label="结案时间"
					prop="caseTime"
				>
				</el-table-column>

				<el-table-column
					v-if="findTable('caseType')"
					width="80px"
					align="center"
					label="赔付责任类型"
					prop="caseType"
				>
				</el-table-column>

				<el-table-column
					v-if="findTable('orgManagement')"
					width="90px"
					align="center"
					label="管理机构"
					prop="orgManagement"
				>
					<template slot-scope="scoped">
						<span>
							{{ getOrg(scoped.row.orgManagement) }}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('branchOffice')"
					width="80px"
					align="center"
					label="分公司"
					prop="branchOffice"
				>
				</el-table-column>
				<el-table-column
					v-if="productFlag == 0"
					width="80px"
					align="center"
					label="数据来源"
				>
					<template slot-scope="scoped">
						<span>
							{{
								scoped.row.dataSource
									| statusFilter(dataSourceList)
							}}
						</span>
					</template>
				</el-table-column>

				<el-table-column
					v-if="productFlag == 1"
					width="80px"
					align="center"
					label="数据来源"
				>
					<template slot-scope="scoped">
						<span>
							{{
								scoped.row.dataSource
									| statusFilter(dataSourceList01)
							}}
						</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('itemNames')"
					width="100px"
					align="center"
					label="服务项目"
					prop="itemNames"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('serviceTypeNames')"
					width="80px"
					align="center"
					label="服务类别"
					prop="serviceTypeNames"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('serviceModeNames')"
					width="100px"
					align="center"
					label="服务提供方式"
					prop="serviceModeNames"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('providerId')"
					width="80px"
					align="center"
					label="供应商"
					prop="providerNames"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('vipLevel')"
					width="80px"
					align="center"
					label="VIP级别"
				>
					<template slot-scope="scoped">
						<span>{{
							vipLevelData[scoped.row.vipLevel] ||
							scoped.row.vipLevel
						}}</span>
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('serviceDepartment')"
					width="80px"
					align="center"
					label="权益来源"
					prop="serviceDepartment"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('activeYear')"
					width="80px"
					align="center"
					label="激活年度"
					prop="activeYear"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('insuranceProductCategory')"
					width="80px"
					align="center"
					label="健康保险产品类别"
					prop="insuranceProductCategory"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('policyNo')"
					width="80px"
					align="center"
					label="保单号"
					prop="policyNo"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('productName')"
					width="80px"
					align="center"
					label="产品名称"
					prop="productName"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('channel')"
					width="80px"
					align="center"
					label="渠道"
					prop="channel"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('serviceStatus')"
					width="80px"
					align="center"
					label="服务状态"
					prop="serviceStatus"
				>
					<template slot-scope="scoped">
						{{
							scoped.row.serviceStatus
								| statusFilter(serverStatus)
						}}
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('status')"
					width="80px"
					align="center"
					label="状态"
					prop="status"
				>
					<template slot-scope="scoped">
						{{ scoped.row.status | statusFilter(statusArr) }}
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('activeBeginTime')"
					width="80px"
					align="center"
					label="激活开始时间"
					prop="activeBeginTime"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('activeEndTime')"
					width="80px"
					align="center"
					label="激活终止时间"
					prop="activeEndTime"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('beginTime')"
					width="80px"
					align="center"
					label="开通时间"
					prop="beginTime"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('endTime')"
					width="80px"
					align="center"
					label="有效止期"
					prop="endTime"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('price')"
					width="80px"
					align="center"
					label="单价"
					prop="price"
				>
				</el-table-column>
				<el-table-column
					v-if="findTable('totalTimes')"
					width="80px"
					align="center"
					label="总次数"
				>
					<template slot-scope="scoped">
						{{
							scoped.row.totalTimes >= 999
								? "无限次"
								: scoped.row.totalTimes
						}}
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('usedTimes')"
					width="80px"
					align="center"
					label="已用次数"
				>
					<template slot-scope="scoped">
						{{
							scoped.row.usedTimes >= 999
								? "无限次"
								: scoped.row.usedTimes
						}}
					</template>
				</el-table-column>
				<el-table-column
					v-if="findTable('availableTimes')"
					width="80px"
					align="center"
					label="剩余次数"
				>
					<template slot-scope="scoped">
						{{
							scoped.row.availableTimes >= 999
								? "无限次"
								: scoped.row.availableTimes
						}}
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 分页部分 -->
		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				@size-change="handleSizeChange"
				:page-sizes="[10, 50, 100]"
				:current-page="searchBox.pageNo"
				:page-size="searchBox.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				background
			>
			</el-pagination>
		</div>
	</el-container>
</template>

<script>
	import getService from "@/mixins/getService.mixin";
	import {
		cardType,
		statusArr,
		serverStatus,
		dataSourceList,
		vipLevelData,
		maritalOption,
		dataSourceList01,
	} from "@/assets/js/options";
	import { dateFormat, dataArrFormat } from "@/assets/js/until.js";
	// 带全选功能的下拉框
	import SelectAll from "@/components/SelectAll";
	import _ from "loadsh";
	export default {
		name: "userEquity",
		components: {
			SelectAll,
		},
		data() {
			var pickerOptions = {
				disabledDate(e) {
					return e.getFullYear() < 2022;
				},
			};
			return {
				pickerOptions,
				maritalOption,
				dataSourceList01,
				cardType, // 证件类型list
				dataSourceList, // 数据来源
				vipLevelData, // vip等级数据
				productFlag: "1", // 标签
				tableHeight: 0,
				tabList: [
					// 页面标签
					{ id: "1", label: "产品级" },
					{ id: "0", label: "非产品级" },
				],
				listData: [],
				searchList: {
					// 数据驱动 标签对应要显示的内容 通过 findTable(name) 函数进行判断是否显示
					1: [
						// 通用
						"serviceNo", // 服务单号
						"branchOffice", // 分公司
						"orgManagement", // 管理机构
						"dataSource", // 数据来源
						"itemNames", // 服务项目
						"serviceTypeId", // 服务类别
						"serviceTypeNames", // 服务类别
						"serviceModeId", // 服务提供方式
						"serviceModeNames", // 服务提供方式
						"providerId", // 供应商
						"policyNoLike", // 保单号
						"policyNo", // 保单号
						"insuranceProductCategories", // 健康 保险产品类别
						"insuranceProductCategory", // 健康 保险产品类别
						"productName", // 产品名称
						"productNameLike", // 产品名称
						"channel", // 渠道
						// "status", // 状态
						"activeBeginTime", // 激活开始时间
						"beginTime", // 开通时间
						// 搜索条件
						"userInfo", // 用户信息
						// table内容
						"userId", // 用户ID
						"name", // 姓名
						"gender", // 性别
						"age", // 年龄
						"cardType", // 证件类型
						"cardNo", // 证件号码
						"mobile", // 联系电话
						"caseType",
						"marital", // 婚姻状况
						"socialSecurityName", //  社保标识 0无 1有
						"caseNumber", // 赔案号
						"caseTime", // 结案时间
						"caseConclusion", // 理赔结论
						"specialContent", // 特约内容
						"serviceStatus", // 服务状态
						"policyStatus", // 婚姻状况
						"activeEndTime", // 激活终止时间
						"endTime", // 有效止期
						"price", // 单价
						"totalTimes", // 总次数
						"usedTimes", // 已用次数
						"availableTimes", // 剩余次数
						"caseNumberLike", // 赔案号
						"caseTypeLike", //赔付责任类型
						"caseTimeBegin", //结案时间起始时间
						"policyStatues", //状态（保单状态)
					],
					0: [
						// 通用
						"serviceNo", // 服务单号
						"orgManagement", // 管理机构
						"branchOffice", // 分公司
						"dataSource", // 数据来源
						"itemNames", // 服务项目
						"serviceTypeId", // 服务类别
						"serviceTypeNames", // 服务类别
						"serviceModeId", // 服务提供方式
						"serviceModeNames", // 服务提供方式
						"providerId", // 供应商
						"activeBeginTime", // 激活开始时间
						"vipLevel", // VIP级别
						"serviceDepartment", // 权益来源
						"activeYear", // 激活年度
						"status", // 状态
						"beginTime", // 开通时间
						// 搜索条件
						"userInfo", // 用户信息
						// table内容
						"userId", // 用户ID
						"name", // 姓名
						"gender", // 性别
						"age", // 年龄
						"cardType", // 证件类型
						"cardNo", // 证件号码
						"mobile", // 联系电话
						"marital", // 婚姻状况
						"activeEndTime", // 激活终止时间
						"endTime", // 有效止期
						"price", // 单价
						"totalTimes", // 总次数
						"usedTimes", // 已用次数
						"availableTimes", // 剩余次数
					],
				},
				policyStatuesArray: [
					{ value: "1", label: "无法匹配 " },
					{ value: "00", label: "有效 " },
					{ value: "01", label: "垫交有效 " },
					{ value: "02", label: "停效 " },
					{ value: "03", label: "终止 " },
					{ value: "04", label: "暂停 " },
					{ value: "05", label: "豁免 " },
					{ value: "06", label: "迁出 " },
					{ value: "07", label: "免交有效 " },
				],
				// table
				loading: false, // loading
				tableData: [], // 列表数据
				timeCache: {}, // 时间存储
				statusArr,
				serverStatus,
				supplierList: [], // 供应商列表
				serviceData: [], // 服务项目产品级非产品级数据
				searchBox: {
					pageNo: 1,
					pageSize: 10,
				},
				optionsData: [],
				serviceModeList: [],
				total: 0, // 总数
			};
		},
		mixins: [getService],
		watch: {
			productFlag() {
				this.clear(); // 清空数据
			},
		},
		created() {
			this.getOptions();
			this.$root.breadList = [
				{ name: "权益中心", link: "" },
				{ name: "用户权益", link: "" },
			];
		},
		mounted() {
			this.$nextTick(() => {
				// this.listenWindow()
				this.getProvisionData();
				this.getSupplierList();
				this.getServiceList();
				this.getData();
			});
		},
		methods: {
			//窗口改变，重新取得高度
			listenWindow() {
				this.tableHeight = this.$refs.tableBox.offsetHeight;
				window.addEventListener("resize", () => {
					clearTimeout(this.resizeFlag);
					this.resizeFlag = setTimeout(() => {
						this.tableHeight = this.$refs.tableBox.offsetHeight;
					}, 300);
				});
			},
			/**
			 * 分页搜索
			 */
			handleCurrentChange(val) {
				this.searchBox.pageNo = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.searchBox.pageNo = 1;
				this.searchBox.pageSize = val;
				this.getData();
			},
			/**
			 * 清空数据
			 */
			clear() {
				this.searchBox = {
					// 搜索条件
					pageNo: 1,
					pageSize: 10,
				};
				this.timeCache = {}; // 时间存储
			},
			/**
			 * 重置按钮
			 */
			goReset() {
				this.clear();
				this.getData();
				// this.$root.showPage = false;
				// this.productFlag = "0";
			},
			/**
			 * 获取table对应的搜索条件
			 */
			findTable(name) {
				return this.searchList[this.productFlag].includes(name);
			},
			/**
			 * 时间回调函数
			 */
			toChangeTime(val, startName, endName) {
				if (val && val.length) {
					// this.$set(this.searchBox, startName, dateFormat(val[0]) + ' 00:00:00');
					// this.$set(this.searchBox, endName, dateFormat(val[1]) + ' 23:59:59');
					this.$set(
						this.searchBox,
						startName,
						new Date(val[0]).getTime()
					);
					this.$set(this.searchBox, endName, new Date(val[1]).getTime());
				} else {
					this.$set(this.searchBox, startName, "");
					this.$set(this.searchBox, endName, "");
				}
			},
			/**
			 * 时间回调函数 单个时间选择器
			 */
			toChangeTimeOne(val, name) {
				if (val) {
					this.$set(this.searchBox, name, new Date(val).getTime());
				} else {
					this.$set(this.searchBox, name, "");
				}
			},
			/**
			 * 查询
			 */
			async getData() {
				// 数据处理
				let param = {
					productFlag: this.productFlag,
					...this.searchBox,
				};
				Object.keys(param).forEach((key) => {
					if (
						Object.prototype.toString.call(param[key]) ===
						"[object Array]"
					) {
						param[key] =
							param[key].length == 1
								? param[key][0]
								: param[key].join(",");
					}
				});
				// 接口请求
				const res = await this.axios.get(this.getApiUrl("cmsRightPage"), {
					params: param,
				});
				if (res.code === 1) {
					this.searchBox.pageNo = res.data.pageNo;
					this.searchBox.pageSize = res.data.pageSize;
					this.total = res.data.total;
					this.tableData = res.data.data || [];
				} else {
					this.$message.warning(res.msg);
				}
			},
			/**
			 *  筛选项数据
			 */
			async getOptions() {
				// 接口请求
				const res = await this.axios.get(
					this.getApiUrl("cmsRightOptions"),
					{
						params: {},
					}
				);
				if (res.code === 1) {
					Object.keys(res.data).forEach((item) => {
						if (
							item != "prodOrgManagementList" &&
							item != "unProdOrgManagementList"
						) {
							res.data[item] = dataArrFormat(res.data[item]);
						} else {
							res.data[item].forEach((content) => {
								content.label = content.orgManagementName
									? content.orgManagementCode +
									  "+" +
									  content.orgManagementName
									: content.orgManagementCode + "+无法匹配到机构";
								content.orgManagementName =
									content.orgManagementName
										? content.orgManagementName
										: "无法匹配到机构";
							});
						}
						if (item == "vipLevelList") {
							res.data[item].forEach((content) => {
								content.label =
									vipLevelData[content.value] || content.value;
							});
						}
					});

					this.optionsData = res.data || {};
				} else {
					this.$message.warning(res.msg);
				}
			},
			/**
			 * 获取服务项目列表
			 */
			async getServiceList() {
				let res = await this.axios.get(this.getApiUrl("itemOptions"), {
					params: {
						pageNo: 1,
						pageSize: 1000,
					},
				});
				this.serviceData = res?.data || {};
			},
			/**
			 * 服务提供方式
			 */
			async getProvisionData() {
				// 接口请求
				let res = await this.axios.get(
					this.getApiUrl("serviceModeTree"),
					{}
				);
				if (res.code === 1) {
					this.serviceModeList = res.data;
				} else {
					this.$message.warning(res.msg);
				}
			},
			/**
			 * 获取供应商列表
			 */
			async getSupplierList() {
				let res = await this.axios.get(this.getApiUrl("providerPage"), {
					params: {
						pageNo: 1,
						pageSize: 1000,
					},
				});
				this.supplierList = res?.data?.data || [];
			},
			toExport() {
				// 数据处理
				let param = {
					productFlag: this.productFlag,
					...this.searchBox,
				};
				delete param.pageNo;
				delete param.pageSize;
				Object.keys(param).forEach((key) => {
					if (
						Object.prototype.toString.call(param[key]) ===
						"[object Array]"
					) {
						param[key] =
							param[key].length == 1
								? param[key][0]
								: param[key].join(",");
					}
				});
				let urlPath = this.getApiUrl("cmsRightExport");
				this.$root.exportFile(urlPath, param, "用户权益导出");
			},
			/**
			 * 切换标签
			 */
			async handleClick() {
				this.searchBox = {
					// 搜索条件
					pageNo: 1,
					pageSize: 10,
				};
				await this.getData();
				console.log(this.productFlag);
				// this.tableHeight = this.$refs.tableBox.offsetHeight;
			},
			toSearch() {
				this.searchBox.pageNo = 1;
				this.searchBox.pageSize = 10;
				this.getData();
			},
			getOrg(text) {
				let list =
					this.productFlag == 1
						? this.optionsData.prodOrgManagementList
						: this.optionsData.unProdOrgManagementList;
				let data = list
					? list.find((e) => _.toNumber(text) == e.orgManagementCode)
					: [];
				if (data) return data.orgManagementName;
				else return "无法匹配到机构";
			},
		},
		filters: {
			statusFilter(text, list) {
				let data = list.find((e) => Number(text) == e.value);
				if (data) return data.label;
				else return text;
			},
		},
	};
</script>

<style type="text/scss" lang="scss" scoped>
	.tableScroll {
		height: 400px;
		overflow-y: scroll;
	}
	.footerInfo {
		margin-top: 30px;
	}
	.search-x {
		min-height: 120px;
		flex-shrink: 0;
		.search-item {
			.label {
				display: inline-block;
				width: 100px;
				text-align: right;
			}
		}
	}
	.cont-x {
		flex: 1;
		flex-shrink: 0;
	}
</style>
